var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pt-0 pb-0"},[_c('v-row',{attrs:{"justify":"center","align":"start"}},[_vm._l((2),function(i){return [_c('v-col',{key:i,attrs:{"md":"4","sm":"6","cols":"12"}},[_c('v-skeleton-loader',{ref:"skeleton",refInFor:true,staticClass:"mx-auto",attrs:{"type":"card"}})],1)]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }